var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"creditpush-main-layout"},[_c('TheCreditpushMainHeader'),_c('router-view'),_c('TheCreditpushMainFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }